(() => {
  const init = (root) => {
    if (!root || root.dataset.offersReady === 'true') return;
    root.dataset.offersReady = 'true';

    const track = root.querySelector('[data-offers-track]');
    if (!track) return;

    const cards = [...track.querySelectorAll('[data-offer-card]')];
    const current = root.querySelector('[data-offers-current]');
    const total = root.querySelector('[data-offers-total]');
    const progress = root.querySelector('[data-offers-progress]');
    const prev = root.querySelector('[data-offers-prev]');
    const next = root.querySelector('[data-offers-next]');
    if (!cards.length) return;

    if (total) total.textContent = String(cards.length).padStart(2, '0');

    let active = 0;
    let raf = null;

    const setActive = (index) => {
      active = Math.max(0, Math.min(cards.length - 1, index));
      if (current) current.textContent = String(active + 1).padStart(2, '0');
      if (progress) progress.style.setProperty('--progress', `${((active + 1) / cards.length) * 100}%`);
    };

    const nearestIndex = () => {
      const trackRect = track.getBoundingClientRect();
      const styles = getComputedStyle(track);
      const rtl = styles.direction === 'rtl';
      const scrollPadding = Number.parseFloat(styles.scrollPaddingInlineStart) || 0;
      const anchor = rtl ? trackRect.right - scrollPadding : trackRect.left + scrollPadding;
      let best = 0;
      let bestDistance = Infinity;
      cards.forEach((card, index) => {
        const r = card.getBoundingClientRect();
        const edge = rtl ? r.right : r.left;
        const distance = Math.abs(edge - anchor);
        if (distance < bestDistance) {
          bestDistance = distance;
          best = index;
        }
      });
      setActive(best);
    };

    track.addEventListener('scroll', () => {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(nearestIndex);
    }, { passive: true });

    const goTo = (index) => {
      const target = cards[Math.max(0, Math.min(cards.length - 1, index))];
      if (!target) return;

      const trackRect = track.getBoundingClientRect();
      const targetRect = target.getBoundingClientRect();
      const styles = getComputedStyle(track);
      const rtl = styles.direction === 'rtl';
      const scrollPadding = Number.parseFloat(styles.scrollPaddingInlineStart) || 0;
      const anchor = rtl ? trackRect.right - scrollPadding : trackRect.left + scrollPadding;
      const delta = rtl ? targetRect.right - anchor : targetRect.left - anchor;

      track.scrollBy({ left: delta, behavior: 'smooth' });
    };

    prev?.addEventListener('click', () => goTo(active - 1));
    next?.addEventListener('click', () => goTo(active + 1));

    setActive(0);
  };

  const initAll = (scope = document) => scope.querySelectorAll('[data-offers-showcase]').forEach(init);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
